"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
function GenericMenuItem({ imgPath, backgroundColor, borderColor, onClick, onMouseOver, onMouseOut }) {
    let parsedImgPath;
    if (imgPath && imgPath.type === 'local') {
        parsedImgPath = `assets/${imgPath.path}`;
    }
    return react_1.default.createElement(material_1.Grid, { item: true, xs: 4, md: 3, lg: 2, direction: 'row', alignItems: 'flex-start', justifyContent: 'flex-start', spacing: 0, style: {
            marginBottom: '3%',
            marginTop: '3%',
        } },
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.ButtonBase, { style: {
                    background: backgroundColor,
                    borderRadius: '15px',
                    borderColor: borderColor,
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    boxShadow: '0 0 0 2px #C79B7B',
                    width: '67px',
                    height: '67px',
                }, onMouseOver: () => {
                    onMouseOver();
                }, onMouseOut: () => {
                    onMouseOut();
                }, onClick: (e) => {
                    e.nativeEvent.stopImmediatePropagation();
                    e.preventDefault();
                    e.stopPropagation();
                    onClick();
                } }, imgPath &&
                react_1.default.createElement("img", { style: {
                        position: 'absolute',
                        width: '44px',
                        pointerEvents: 'none',
                    }, src: parsedImgPath }))));
}
exports.GenericMenuItem = GenericMenuItem;
